export default {
  BAR: "BAR",
  LINE_SIMPLE: "LINE_SIMPLE",
};
